import { render, staticRenderFns } from "./DiscountCodePager.vue?vue&type=template&id=c8b93820&scoped=true&"
import script from "./DiscountCodePager.vue?vue&type=script&lang=js&"
export * from "./DiscountCodePager.vue?vue&type=script&lang=js&"
import style0 from "./DiscountCodePager.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DiscountCodePager.vue?vue&type=style&index=1&id=c8b93820&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b93820",
  null
  
)

export default component.exports